import React, { useState, useContext, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ConnectorContext } from '../../../context';
import { applicationMessageId } from '../../../utils';

export const StartAuthTitleContent = ({ isStartedConnection }) => {
  const [seconds, setSeconds] = useState(3);
  const {
    state: {
      currentApp: { name, code, version },
    },
  } = useContext(ConnectorContext);
  const intl = useIntl();
  const messageId = (id) => applicationMessageId(intl.messages, id, code, version);

  const startCountdown = () => {
    const countdown = setTimeout(() => setSeconds(seconds - 1), 1000);

    return () => {
      clearTimeout(countdown);
    };
  };

  useEffect(() => {
    if (isStartedConnection && seconds > 0) {
      startCountdown();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStartedConnection, seconds]);

  return (
    <Grid item xs sx={{ paddingBottom: '30px', minHeight: '100px' }}>
      <Typography gutterBottom>
        <FormattedMessage
          id={messageId(isStartedConnection ? 'connection_title' : 'pre_connection_title')}
          values={{ appName: name }}
        />
      </Typography>
      <Typography variant="subtitle">
        <FormattedMessage
          id={messageId(isStartedConnection ? 'connection_subtitle' : 'pre_connection_subtitle')}
          values={{ appName: name, seconds }}
        />
      </Typography>
    </Grid>
  );
};

StartAuthTitleContent.propTypes = {
  isStartedConnection: PropTypes.bool.isRequired,
};
